import { z } from 'zod';

export const validationFailureMessageSchema = z.object({
  failureMessage: z
    .string()
    .trim()
    .min(1)
    .max(120)
    .regex(/^[^\r\n]+$/)
    .optional(),
});

export type ValidationFailureMessage = z.infer<
  typeof validationFailureMessageSchema
>;

/** Selects concise wording for a failed check without changing its verdict. */
export function getValidationDisplayMessage(
  result: { message: string; output?: unknown; failureMessage?: unknown },
  preferFailureMessage: boolean
): string {
  if (!preferFailureMessage || !result.output || result.output === 'false') {
    return result.message;
  }
  const parsed = validationFailureMessageSchema.safeParse(result);
  return parsed.success
    ? parsed.data.failureMessage ?? result.message
    : result.message;
}
